import { Flex } from "@chakra-ui/react";
import { StatCard, StatCardProps } from "./StatCard";

type StatCardsContainerProps = {
  items: StatCardProps[];
  orientation?: "horizontal" | "vertical";
  mb?: number;
};

const StatCardsContainer = ({
  items,
  orientation = "horizontal",
  mb = 4,
}: StatCardsContainerProps) => {
  return (
    <Flex
      wrap="wrap"
      flexDirection={orientation === "horizontal" ? "row" : "column"}
      gap="4"
      mb={mb}
      w="100%"
    >
      {items.map((item, index) => {
        const { onClick, isActive } = item;
        return (
          <Flex
            key={index}
            flex={1}
            onClick={onClick}
            cursor={onClick ? "pointer" : undefined}
            transition="opacity 0.15s ease, box-shadow 0.15s ease"
            outline={isActive ? "2px solid" : undefined}
            outlineColor={isActive ? "teal.400" : undefined}
            borderRadius={isActive ? "md" : undefined}
            _hover={onClick ? { opacity: 0.85 } : undefined}
          >
            <StatCard {...item} />
          </Flex>
        );
      })}
    </Flex>
  );
};

export { StatCardsContainer };
